import { useEffect } from "react";
import { track } from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";
import SEO from "@/components/SEO";
import { ShieldCheck } from "lucide-react";

export default function Privacy() {
  const { settings } = useSettings();
  useEffect(() => { track("page_view", "privacy"); }, []);

  return (
    <div>
      <SEO title="Informativa Privacy" description="Informativa sul trattamento dei dati personali del Ristorante Masetti." />
      <div className="max-w-2xl mx-auto px-4 sm:px-6 py-14">
        <ShieldCheck className="w-9 h-9 text-brass mb-3" />
        <h1 className="font-serif text-3xl sm:text-4xl text-bordeaux">Informativa Privacy</h1>
        <p className="text-oak/60 text-sm mt-1">Trattamento dei dati personali ai sensi del Regolamento UE 2016/679 (GDPR).</p>

        <div className="prose-masetti mt-8 space-y-6 text-oak/85 leading-relaxed">
          <section>
            <h2 className="font-serif text-xl text-bordeaux">Titolare del trattamento</h2>
            <p>Ristorante Masetti, Via Gesso 70, 40069 Zola Predosa (BO).{settings.email ? <> Email: <a className="text-bordeaux underline underline-offset-2" href={`mailto:${settings.email}`}>{settings.email}</a>.</> : null}{settings.phone_primary ? ` Tel: ${settings.phone_primary}.` : ""}</p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-bordeaux">Quali dati raccogliamo</h2>
            <p>Raccogliamo solo i dati che ci fornisci volontariamente tramite i moduli del sito: prenotazioni tavoli, richieste per gruppi ed eventi, iscrizione al motoraduno e adesione alle comunicazioni. Possono includere nome, cognome, telefono, email e il numero di persone.</p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-bordeaux">Motoraduno</h2>
            <p>Se ti iscrivi al motoraduno, i dati inseriti (nome, cognome, telefono, numero di partecipanti, moto e persone a pranzo) sono usati esclusivamente dal ristorante per organizzare il giro e il pranzo e per contattarti in caso di variazioni. Non vengono condivisi con terzi né con gli altri partecipanti.</p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-bordeaux">Finalità e base giuridica</h2>
            <p>Utilizziamo i dati esclusivamente per gestire la tua richiesta o la tua partecipazione e per contattarti in merito. Le comunicazioni marketing avvengono solo con il tuo consenso esplicito, revocabile in qualsiasi momento.</p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-bordeaux">Conservazione</h2>
            <p>Conserviamo i dati per il tempo necessario alle finalità indicate e li eliminiamo quando non più necessari o su tua richiesta.</p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-bordeaux">I tuoi diritti</h2>
            <p>Puoi richiedere in ogni momento l’accesso, la rettifica o la cancellazione dei tuoi dati, oltre alla limitazione o all’opposizione al trattamento, scrivendo{settings.email ? <> a <a className="text-bordeaux underline underline-offset-2" href={`mailto:${settings.email}`}>{settings.email}</a></> : " al ristorante"}.</p>
          </section>

          <p className="text-xs text-oak/50">I dati non vengono ceduti a terzi per finalità commerciali. Questa informativa può essere aggiornata: fa fede la versione pubblicata su questa pagina.</p>
        </div>
      </div>
    </div>
  );
}
